<template>
  <div class="min-h-screen">
    <HomeClients />
    <CTA />
  </div>
</template>

<script setup>
defineOptions({ name: "ClientsPage" });
import HomeClients from "@/components/home/Clients.vue";
import CTA from "@/components/home/CTA.vue";
import { useSeo } from "@/composables/useSeo";

useSeo({
  title: "Clientes | Kali Sistemas",
  description:
    "Conheça empresas que confiam na Kali Sistemas para gerir suas operações com mais eficiência e tecnologia.",
});
</script>
